import UpdatesCharts from './UpdatesCharts';

export default UpdatesCharts;
